var frequencyToLabel = {
  WEEK: 'Weekly',
  FRTN: 'Every two weeks',
  '4WEK': 'Every four weeks',
  MNTH: 'Monthly',
  '2MTH': 'Every two months',
  QURT: 'Quarterly',
  '4MTH': 'Every four months',
  MIAN: 'Half Yearly',
  YEAR: 'Yearly'
};
export function parseFrequency(frequency) {
  return frequencyToLabel[frequency] || '';
}